
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-data-grid/server-side-data/tree-data",
      function () {
        return require("private-next-pages/x/react-data-grid/server-side-data/tree-data.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-data-grid/server-side-data/tree-data"])
      });
    }
  